import {
  DESKTOP_DRAWER_WIDTH,
  COLLAPSED_DESKTOP_DRAWER_WIDTH,
  COLLAPSE_SIDEBAR_ICON_BOTTOM_PADDING_REM,
} from '~/common/constants/layout-constants'

export const drawerPaperSx = (width) => ({
  '& .MuiDrawer-paper': {
    boxSizing: 'border-box',
    width,
    transition: (theme) =>
      theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    overflowX: 'hidden',
  },
})

export const collapseButtonSx = ({ collapsed, palette }) => ({
  position: 'fixed',
  bottom: COLLAPSE_SIDEBAR_ICON_BOTTOM_PADDING_REM,
  left: collapsed ? `${COLLAPSED_DESKTOP_DRAWER_WIDTH}px` : `${DESKTOP_DRAWER_WIDTH}px`,
  transform: 'translateX(-50%)',
  border: 1,
  borderColor: 'divider',
  boxShadow: 2,
  bgcolor: palette.primary.light,
  color: 'primary.contrastText',
  transition: (theme) =>
    theme.transitions.create('left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  '&:hover': {
    bgcolor: palette.primary[500],
  },
  zIndex: (theme) => theme.zIndex.drawer + 2,
})

// pl: 2 = 16px — centers a 24px icon in the 56px collapsed zone; same position in both states
export const listItemButtonSx = {
  justifyContent: 'initial',
  p: 1,
  '&.Mui-selected .MuiListItemIcon-root': {
    color: 'primary.main',
  },
  '&:hover .MuiListItemIcon-root': {
    color: 'primary.main',
  },
}

export const listItemIconSx = {
  minWidth: 0,
  mr: 3,
  justifyContent: 'center',
  flexShrink: 0,
}
